<div>
    <textarea rows="20" nz-input [(ngModel)]="students"></textarea>
    <button  nzSize="large" nz-button nzType="primary" (click)="save()" [nzLoading]="isSaving">Save!</button>
</div>
